import { base } from "@base-provider";

export const getTypeaheadResults = async (url, urlData) => {
  return base.post({ url: url, data: urlData });
};
